import styles from "./home.module.css";
import Timeline from "../../components/Timeline/Timeline";
import ThankYouSlide from "../../components/Thankyou/ThankYouSlide";
import TestimonialCarousel from "../../components/reviews/reviews";
import Homecompo from "../../components/home/home";
import Location from "../../components/location/location";
import SpeakersSection from "../../components/Speakers/SpeakersSection";
const Home = () => {
    return (
        <div>
            <Homecompo></Homecompo>
            <SpeakersSection></SpeakersSection>
            <ThankYouSlide />
            <Timeline></Timeline>
            <TestimonialCarousel />
            <Location></Location>
        </div>
    );
}
 
export default Home;